import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 16 16" focusable="false" fill="currentColor" aria-hidden="true"><g fill="none" fillRule="evenodd"><path d="M2.275 0C1.575 0 1 .55 1 1.25v13.475c0 .7.575 1.275 1.275 1.275h11.45c.7 0 1.275-.575 1.275-1.275v-9.65L10.275 0h-8Z" fill="#66A3FF" fillRule="nonzero" /><text fontFamily="PingFangSC-Semibold, PingFang SC" fontSize={4} fontWeight={500} fill="#FFF"><tspan x={3.5} y={13}>{"DOC"}</tspan></text><path d="M10.275 0v3.65c0 .4.275 1.45 1.525 1.45H15L10.275 0Z" fill="#A3C8FF" fillRule="nonzero" /></g></svg>

const Word = React.forwardRef((props, ref) => {
  return (
    <IconBase name="word" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Word.displayName = 'IconWord'

export default Word
